// Angular modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Third party modules
import { TabsModule } from 'ngx-bootstrap/tabs';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DataTablesModule } from 'angular-datatables';

export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    containerClass: 'theme-green',
    showWeekNumbers: false
  });
}

// routing module
import { SharedRoutingModule } from './shared-routing.module';

// Application Components
//import { BrokerAddComponent } from '../masters/brokerage/broker-add.component';
//import { BrokerageAddComponent } from '../masters/brokerage/brokerage-add.component';
import { FileuploadComponent } from '../shared/fileupload/fileupload.component';
import { MessagesComponent } from './messages/messages.component';
import { MessageInputComponent } from './messages/message-input/message-input.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  imports: [
    CommonModule,
    SharedRoutingModule,
    HttpClientModule,
    FormsModule,
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ReactiveFormsModule,
    DataTablesModule,
    PopoverModule.forRoot()
  ],
  declarations: [FileuploadComponent, MessagesComponent, MessageInputComponent ],
  exports: [FileuploadComponent, MessagesComponent, MessageInputComponent],
  providers: [
    { provide: BsDatepickerConfig, useFactory: getDatepickerConfig }
  ]
})
export class SharedModule { }
